import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import PatientNotesTable from './PatientNotesTable';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import AddEditNotesForm from './AddEditNotesForm';

const propTypes = {
    patientId: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
};
const PatientNotesModal = ({ patientId, showModal, onHide }) => {
    const [showAddEditForm, setShowAddEditForm] = useState(false);
    const [editingNote, setEditingNote] = useState({});
    const openAddEditForm = (note = null) => {
        setEditingNote(note);
        setShowAddEditForm(true);
    };
    return (
        <Modal show={showModal} backdrop="static" className="patient-view-profile-notes" size="lg">
            <Modal.Header>
                <Modal.Title role="heading">Patient Notes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PatientNotesTable
                    patientId={patientId}
                    editNote={openAddEditForm}
                    showForm={setShowAddEditForm}
                    editingNote={editingNote}
                    isFormOpen={showAddEditForm}
                />
            </Modal.Body>
            <Modal.Footer>
                <div className="w-100">
                    <Row>
                        <Col md={12}>
                            <FormButtonGroup>
                                <Button
                                    variant="outline-secondary"
                                    id="view-notes-close-modal-button"
                                    type="button"
                                    onClick={() => {
                                        onHide();
                                    }}
                                    disabled={showAddEditForm}
                                >
                                    Close
                                </Button>
                                <Button
                                    variant="primary"
                                    id="add-notes-button"
                                    type="button"
                                    disabled={showAddEditForm}
                                    onClick={() => openAddEditForm()}
                                >
                                    Add Note
                                </Button>
                            </FormButtonGroup>
                        </Col>
                    </Row>
                    {showAddEditForm && (
                        <AddEditNotesForm
                            patientId={patientId}
                            onHide={() => {
                                setShowAddEditForm(false);
                            }}
                            note={editingNote}
                            key={editingNote?.uuid}
                        />
                    )}
                </div>
            </Modal.Footer>
        </Modal>
    );
};

PatientNotesModal.propTypes = propTypes;

export default PatientNotesModal;
